<template>
  <v-simple-table fixed-header>
    <template v-if="loading">
      <Load :loadingmsg="loadingMsg" />
    </template>
    <div
      v-else
    >
      <v-data-table
        :headers="headers"
        :items="contents"
        :items-per-page="10"
        item-key="id"
      >
        <template #item.name="{ item }">
          {{ item.name }}
        </template>
        <template #item.status="{ item }">
          {{ item.status ? 'Ativo' : 'Inativo' }}
        </template>
        <template #item.grade_volume_id="{ item }">
          {{ volumes.find(volume => volume.id === item.grade_volume_id)?.name || 'Sem Volume' }}
        </template>
        <template #item.grade_subject_id="{ item }">
          {{ subjects.find(subject => subject.id === item.grade_subject_id)?.name || 'Sem matéria' }}
        </template>
        <template #item.created_at="{ item }">
          <v-btn
            class="mx-2"
            outlined
            small
            fab
            color="primary"
            @click="openFormEditItemDialog(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            class="mx-2"
            outlined
            small
            fab
            color="primary"
            @click="confirmDelete(item)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </v-simple-table>
</template>

<script>
import Load from '@/components/Loading.vue'
import FormNewUnitDialog from './FormNewUnitDialog.vue'
import FormEditUnitDialog from './FormEditUnitDialog.vue'

import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
    Load
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      gradeUnitView: false,
      loading: false,
      loadingMsg: '',
      contents: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Matéria',
          align: 'start',
          value: 'grade_subject_id'
        },
        {
          text: 'Volume',
          align: 'start',
          value: 'grade_volume_id'
        },
        {
          text: 'Ordem',
          align: 'start',
          value: 'order'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'status'
        },
        {
          text: 'Ações',
          align: 'start',
          value: 'created_at'
        }
      ]
    }
  },

  computed: {
    gradeID () {
      return this.$route.params.gradeID
    }
  },
  mounted () {
    this.fetchAll()
  },
  methods: {

    async fetchAll () {
      await this.listGradeSubjects()
      await this.listGradeVolumes()
      await this.listGradeUnits()
      this.gradeUnitView = true
    },
    async listGradeUnits () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        this.contents = await this.$api.listGradeUnits(this.gradeID)
        // await this.$api.getGradeUnit(this.contents[0].id)
      } catch (e) {
        this.getErrors(e)
      }
      this.loading = false
    },
    async listGradeSubjects () {
      try {
        this.subjects = await this.$api.listGradeSubjects(this.gradeID)
        // await this.$api.getGradeSubject(this.subjects[0].id)
      } catch (e) {
        this.getErrors(e)
      }
    },

    async listGradeVolumes () {
      try {
        this.volumes = await this.$api.listGradeVolumes(this.gradeID)
        // await this.$api.getGradeVolume(this.volumes[0].id)
      } catch (e) {
        this.getErrors(e)
      }
    },
    openFormAddNewitemDIalog () {
      this.$dialog.custom(FormNewUnitDialog).with({ title: 'Tópico', subjects: this.subjects, volumes: this.volumes, action: this.newGradeUnit }).show()
        .then((unit) => {
          if (!unit) {
            return false
          }
          this.listGradeUnits()
        })
    },
    openFormEditItemDialog (unit) {
      this.$dialog.custom(FormEditUnitDialog).with({ title: 'Tópico', subjects: this.subjects, volumes: this.volumes, item: unit, action: this.updateGradeUnit }).show()
        .then((updatedUnit) => {
          if (!updatedUnit) {
            return false
          }
          this.listGradeUnits()
        })
    },
    async newGradeUnit (data) {
      await this.$api.newGradeUnit(this.gradeID, data)
    },
    async updateGradeUnit (id, data) {
      await this.$api.updateGradeUnit(id, data)
    },
    async confirmDelete (item) {
      this.$dialog.confirm(`Apagar ${item.name}?`)
        .text('Tem certeza que deseja apagar? não será possível reverter')
        .label('Apagar')
        .onConfirm(async () => {
          await this.deleteGradeUnit(item.id)
        })
        .show()
    },
    async deleteGradeUnit (id) {
      try {
        await this.$api.deleteGradeUnit(id)
        this.$store.dispatch('setSnackBar', { text: 'Tópico apagado com sucesso.' })
        this.listGradeUnits()
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível apagar o Tópico, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
<style scoped>
.negativeContainer {
  margin: -32px;
  border-left: 0px;
  border-right: 0px;
}
</style>
